import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'antd'
import $t from '../../../../i18n'
import Dialog from '../../../common/Dialog'
import Actions from '../../../../actions'
import Alert from '../../../common/Alert'
import { clinicTypes } from '../../../../consts'
import { event, eventTypes } from '../../../../consts/eventConsts'
import config from '../../../../config.json'

import '../../DeclareLocation/DeclareLocation.css'

const MedcareOrMedcaidCheckDialog = ({ handleSubmit }) => {
  const dispatch = useDispatch()
  const { selectedPlan } = useSelector(state => state?.payment)
  const isOnPaymentPlansPage = useSelector(
    state => state?.chat?.isOnPaymentPlansPage
  )
  const isMedicareModalOpen = useSelector(
    state => state.payment.isMedicareDialogOpen
  )
  const isPPF = useSelector(state => state?.payment?.selectedPlan?.ppf)
  const isGifting = useSelector(state => state?.payment?.selectedPlan?.gifting)
  const [shouldDisplayMedicareStep, setShouldDisplayMedicareStep] =
    useState(true)
  const [shouldDisplayMedicareAlert, setShouldDisplayMedicareAlert] =
    useState(false)
  const [
    shouldDisplayMedicareAreYouSureAlert,
    setShouldDisplayMedicareAreYouSureAlert,
  ] = useState(false)
  const isGiftingMVP = useSelector(
    state => state?.payment?.selectedPlan?.is_gifting_mvp
  )

  const onAbort = () => {
    dispatch(Actions.createAction(Actions.REQUEST_CLOSE_MEDICARE_DIALOG))
  }

  const onSubmit = () => {
    handleSubmit()
    if (!isOnPaymentPlansPage && (isPPF || isGifting)) {
      dispatch(
        Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
          eventName: 'ppf_medicare_no',
          data: { planName: selectedPlan?.plan_name, planId: selectedPlan?.id },
        })
      )
    }

    if (!isOnPaymentPlansPage && !isPPF && !isGifting) {
      // if (selectedPlan?.clinic === clinicTypes.HTN) {
      //   dispatch(
      //     Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
      //       eventName: 'medicare_no_htn',
      //     })
      //   )
      // } else if (selectedPlan?.clinic === clinicTypes.MENTAL) {
      //   dispatch(
      //     Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
      //       eventName: 'medicare_no_mh',
      //     })
      //   )
      // }
      dispatch(
        Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
          type: eventTypes.formEvent,
          eventName: event.formEvent.submit,
          data: {
            question_text: dialogTitle,
            answer_text: 'No',
          },
          element: 'Medicare/Medicaid',
        })
      )
    }
  }

  const medicareStepActions = [
    <Button key="2" className="dialog-action" type="primary" onClick={onSubmit}>
      {$t('common.no')}
    </Button>,
    <Button
      key="1"
      className="dialog-action"
      type="secondary"
      onClick={() => setShouldDisplayMedicareAreYouSureAlert(true)}
    >
      {$t('common.yes')}
    </Button>,
  ]

  const medicareStepTitle = shouldDisplayMedicareAlert ? (
    <div className="no-service-title">
      {$t('dialogs.locationVerify.medicareOrMedicate.noService.title')}
    </div>
  ) : (
    $t('dialogs.locationVerify.medicareOrMedicate.title')
  )

  const dialogTitle = medicareStepTitle

  return (
    <Dialog
      title={dialogTitle}
      isVisible={isMedicareModalOpen}
      footerActions={false}
      onCancel={onAbort}
      className="declare-location-dialog"
    >
      <div className="dialog-content bnpl-medcare">
        {shouldDisplayMedicareStep ? (
          <div className="medicare-step">
            <div className="ant-modal-footer medicare-actions">
              {medicareStepActions}
            </div>
            <div className="medicare-note">
              <span className="bold">
                {' '}
                {$t('dialogs.locationVerify.medicareOrMedicate.noteTitle')}{' '}
              </span>{' '}
              {$t('dialogs.locationVerify.medicareOrMedicate.note1')}
            </div>
          </div>
        ) : (
          <div>
            <p className="no-service-description">
              {$t('dialogs.locationVerify.medicareOrMedicate.noService.desc')}
            </p>
            <Button
              className="Medcare-close"
              onClick={() => {
                window.open(config.whatsappURL, '_self')
              }}
              type="primary"
            >
              {$t('dialogs.locationVerify.medicareOrMedicate.noService.close')}
            </Button>
          </div>
        )}
      </div>
      <Alert
        className="medcaid-or-medicare-alert"
        title={$t('dialogs.locationVerify.medicareOrMedicate.areYouSure')}
        shouldDisplay={shouldDisplayMedicareAreYouSureAlert}
        actions={[
          <Button
            key="1"
            className="dialog-action"
            type="primary"
            onClick={() => {
              setShouldDisplayMedicareAreYouSureAlert(false)
            }}
          >
            {$t('common.no')}
          </Button>,
          <Button
            key="2"
            className="dialog-action"
            type="secondary"
            onClick={() => {
              setShouldDisplayMedicareAreYouSureAlert(false)
              setShouldDisplayMedicareAlert(true)
              setShouldDisplayMedicareStep(false)
              if (!isOnPaymentPlansPage && (isPPF || isGifting)) {
                dispatch(
                  Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
                    eventName: 'ppf_medicare_yes',
                    data: {
                      planName: selectedPlan?.plan_name,
                      planId: selectedPlan?.id,
                    },
                  })
                )
              }
              if (!isOnPaymentPlansPage && !isPPF && !isGifting) {
                if (selectedPlan?.clinic === clinicTypes.HTN) {
                  dispatch(
                    Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
                      eventName: 'medicare_yes_htn',
                    })
                  )
                } else if (selectedPlan?.clinic === clinicTypes.MENTAL) {
                  dispatch(
                    Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
                      eventName: 'medicare_yes_mh',
                    })
                  )
                }
              }
            }}
          >
            {$t('common.yes')}
          </Button>,
        ]}
        onOk={() => setShouldDisplayMedicareAreYouSureAlert(false)}
      />
    </Dialog>
  )
}

export default MedcareOrMedcaidCheckDialog
